/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_It_Skills_HintInputs */

const en_register_onboarding_personal_info_it_skills_hint = /** @type {(inputs: Register_Onboarding_Personal_Info_It_Skills_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please indicate in parentheses how well you master the skills with a grade from 1 to 5.`)
};

const de_register_onboarding_personal_info_it_skills_hint = /** @type {(inputs: Register_Onboarding_Personal_Info_It_Skills_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib in Klammern an, wie gut du die Fähigkeiten beherrschst (Note von 1 bis 5).`)
};

/**
* | output |
* | --- |
* | "Please indicate in parentheses how well you master the skills with a grade from 1 to 5." |
*
* @param {Register_Onboarding_Personal_Info_It_Skills_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_it_skills_hint = /** @type {((inputs?: Register_Onboarding_Personal_Info_It_Skills_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_It_Skills_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_it_skills_hint(inputs)
	return en_register_onboarding_personal_info_it_skills_hint(inputs)
});